<template>
  <div class="header h-padding">
    <div class="school-profile-widget" v-if="$route.name === 'crm' && getToolbar.company">
      <button type="button" @click="toogleNavigation()" class="btn btn-menu">
        <img src="@/assets/icons/main-menu.svg" />
      </button>

      <div class="school-profile-image">
        <img v-if="getToolbar.company && getToolbar.company.logo"
          :src="$fullUrl('images/profiles/' + getToolbar.company.logo)" />
        <img v-else src="../../assets/avatar.png" />
      </div>

      <div class="school-profile-name" v-if="getToolbar.company">
        {{ getToolbar.company.name }}
      </div>
    </div>
    <div class="__contents-items">
      <div class="logo__search">
        <div class="band">
          <router-link to="/feeds" class="norm">
            <img src="../../assets/icons/log2.svg" alt width="141px" />
          </router-link>
          <router-link to="/feeds" class="mob">
            <img src="../../assets/icons/log__circl.svg" alt width="25px" />
          </router-link>
        </div>
        <div class="search" :class="{
          full: $route.name != 'crm' && getToolbar.user.account_type == 3,
        }">
          <widgetSearch placeholder="Search here" autocomplete="off" v-model="searchHeader" @keypress.enter="
            $router.push({ name: 'search', params: { query: searchHeader } }),
            (hideSearch = true)
            " class="search-input" icon="right"></widgetSearch>

          <div class="__results" v-show="!hideSearch && searchHeader" v-closable="{
            exclude: ['bt-toggle-dropdown'],
            handler: 'hideSearchResult',
          }">
            <!-- Search result for people -->
            <div class="result-header">People</div>
            <div class="__item" v-if="toggleSearch" v-for="(user, i) in search_result.people"
              @click="gotoProfile(user, 'people')" :key="i + 'djs'">
              <img v-if="user.profile_picture" :src="$fullUrl('images/profiles/' + user.profile_picture)" />
              <img v-else src="../../assets/avatar.png" alt />
              <div class="__col">
                <span class="__names">{{ user.first_name | validate }}
                  {{ user.last_name | validate }}</span>
              </div>
            </div>
            <!-- Search result for companies -->
            <div class="result-header">Schools</div>
            <div class="__item" v-if="toggleSearch" v-for="(company, i) in search_result.companies"
              @click="gotoProfile(company, 'companies')" :key="i">
              <img v-if="company.logo" :src="$fullUrl('images/profiles/' + company.logo)" />
              <img v-else src="@/assets/icons/logo_avatar.svg" />
              <div class="__col">
                <span class="__names">{{ company.name | validate }}</span>
              </div>
            </div>
            <!-- Search result for assingments -->
            <div class="result-header">Lia</div>
            <div class="__item" v-if="toggleSearch" v-for="(lead, i) in search_result.leads"
              @click="gotoProfile(lead, 'assignments')" :key="i + 'saja'">
              <img v-if="lead.cover_photo" :src="$fullUrl('images/profiles/' + lead.cover_photo)" />
              <img v-else src="@/assets/icons/logo_avatar.svg" />
              <div class="__col">
                <span class="__names">{{ lead.title | validate }}</span>
              </div>
            </div>

            <!-- Tags search result -->
            <div class="__item" v-if="!toggleSearch" v-for="(tag, i) in getTags" @click="gotoTag(tag.name)" :key="i">
              <div class="hash">
                <span>#</span>
              </div>
              <div class="__col">
                <span class="__username">#{{ tag.name | validate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="white--text __bar">



        <router-link to="/feeds" :class="{ __active: $route.name === 'feeds' }" style="position: relative">
          <img v-if="$route.name === 'feeds'" src="@/assets/icons/menu_icons/desktop/home_active.svg" class="m__1" />
          <img v-else src="@/assets/icons/menu_icons/desktop/home.svg" class="m__1" />
          <div class="dot"></div>
        </router-link>


        <router-link to="/lia" :class="{ __active: $route.name === 'lia' }" style="position: relative">
          <img v-if="$route.name === 'lia'" src="@/assets/icons/menu_icons/desktop/lia-active.svg" class="m__1" />
          <img v-else src="@/assets/icons/menu_icons/desktop/lia.svg" class="m__1" />
          <div class="dot"></div>
        </router-link>




        <router-link to="/messages" :class="{ __active: $route.name === 'messages' }" style="position: relative">
          <img v-if="$route.name === 'messages'" src="@/assets/icons/menu_icons/desktop/message_active.svg"
            class="m__1" />
          <img v-else src="@/assets/icons/menu_icons/desktop/message.svg" class="m__1" />
          <div class="dot"></div>
          <div class="badge" v-show="getToolbar.messages > 0">
            {{ getToolbar.messages | validate }}
          </div>
        </router-link>


        <router-link to="/notifications" :class="{ __active: $route.name === 'notifications' }"
          style="position: relative">
          <img v-if="$route.name === 'notifications'" src="@/assets/icons/menu_icons/desktop/notification_active.svg"
            class="m__1" />
          <img v-else src="@/assets/icons/menu_icons/desktop/notification.svg" class="m__1" />
          <div class="dot"></div>
          <div class="badge" v-show="getToolbar.notifications.length > 0 &&
            $route.name !== 'notifications'
            ">
            {{ getToolbar.notifications.length | validate }}
          </div>
        </router-link>


        <router-link v-if="getToolbar.user.account_type == 1 ||
          getToolbar.user.account_type == 4 ||
          getToolbar.user.account_type == 3
        " to="/profile/consultant" :class="{ __active: $route.name === 'consultant-profile' }"
          style="position: relative">
          <img v-if="getToolbar.user.profile_picture" :src="$fullUrl('images/profiles/' + getToolbar.user.profile_picture)
            " class="profile img" />
          <img v-else src="../../assets/avatar.png" alt class="profile img" />
          <div class="dot"></div>
        </router-link>


        <router-link v-if="getToolbar.user.account_type == 2" to="/profile/customer"
          :class="{ __active: $route.name === 'profile-customer' }" style="position: relative">
          <img v-if="getToolbar.user.profile_picture" :src="$fullUrl('images/profiles/' + getToolbar.user.profile_picture)
            " class="profile img" />
          <img v-else src="../../assets/avatar.png" alt class="profile img" />
          <div class="dot"></div>
        </router-link>


        <router-link v-if="getToolbar.user.account_type == 3 || getToolbar.user.account_type == 2"
          :to="getToolbar.user.account_type == 3 ? '/crm' : '/comp/crm'" :class="{
            __active: $route.name === 'crm',
          }" style="position: relative">

          <img v-if="$route.name === 'crm'" src="@/assets/icons/menu_icons/desktop/crm.svg" class="m__1" />
          <img v-else-if="$route.name === 'company-crm'" src="@/assets/icons/menu_icons/desktop/crm.svg" class="m__1" />
          <img v-else src="@/assets/icons/menu_icons/desktop/crm.svg" class="m__1" />
          <div class="dot"></div>
        </router-link>

        <div class="lt">
          <img v-if="$route.name === 'settings'" class="img" src="@/assets/icons/menu_icons/desktop/settings_active.svg"
            ref="bt-toggle-dropdown" @click="hideMenu = !hideMenu" />
          <img v-else class="img" src="@/assets/icons/menu_icons/desktop/settings.svg" ref="bt-toggle-dropdown"
            @click="hideMenu = !hideMenu" />
          <div class="dot"></div>
          <div class="__dropdown-results" v-closable="{
            exclude: ['bt-toggle-dropdown'],
            handler: 'hideDropDownMenu',
          }" v-show="hideMenu">
            <div class="__dropdown-item" v-if="userType">
              <router-link to="/settings">
                <span>Settings</span>
              </router-link>
            </div>
            <div class="__dropdown-item" v-if="getToolbar.user.account_type == 3 && $route.name === 'crm'">
              <a @click.prevent="(show_crm_settings = true), (hideMenu = false)">
                <span>CRM Settings</span>
              </a>
            </div>
            <div class="__dropdown-item">
              <a href="logout" @click.prevent="logOut">
                <span>Log out</span>
              </a>
            </div>
          </div>
        </div>


        <a href="https://wiki.meritios.com/en/home/" target="_blank" class="router-link-active"
          style="position: relative;">
          <img src="@/assets/icons/menu_icons/desktop/question.svg" class="m__1">
        </a>

      </div>
    </div>

    <!-- Crm settings -->
    <CRMSettings @close="show_crm_settings = false" v-if="show_crm_settings"></CRMSettings>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import router from "@/router.js";
import CRMSettings from "@/components/Partials/CRMSettings.vue";

export default {
  name: "header-two",
  components: {
    CRMSettings,
  },
  sockets: {
    connect: function () { },
    notification: function (payload) {
      if (payload.id === this.userId) {
        // this.$store.dispatch("SET_TITLE_BAR_INFO", {notifications : this.getToolbar.notifications + 1,
        //   unreads : this.getToolbar.unreads})
        console.log("notified" + payload);
      }
    },
    message: function (payload) {
      if (payload.id === this.userId && this.$route.name !== "messages") {
        this.$store.dispatch("SET_TITLE_BAR_INFO", {
          messages: this.getToolbar.messages + 1,
        });
        this.playSound();
      }
    },
    network: function (payload) {
      if (payload.id === this.userId) {
        this.networks = this.networks + 1;
      }
    },
    logOut() {
      this.$store.dispatch("AUTH_LOGOUT");
      this.$cookies.remove("project-token");
      this.$cookies.remove("employment-token");
      this.$router.push({ name: "login" });
    },
  },
  data() {
    return {
      hideHomeMenu: false,
      show_crm_settings: false,
      audio: null,
      isEditing: false,
      toggleSearch: true,
      showNotification: false,
      model: null,
      hideSearch: true,
      descriptionLimit: 60,
      entries: [],
      isLoading: false,
      searchHeader: null,
      menus: [
        { title: "Profile", path: "user-profile" },
        //TODO:make a logout url
        { title: "Logout", path: "user-profile" },
      ],
      overflows: [
        { title: "Home", path: "/feeds" },
        { title: "Network", path: "/network" },
        { title: "Messages", path: "/messages" },
        { title: "Notification", path: "/notifications" },
      ],
      hideMenu: false,
      search_result: {
        people: [],
        leads: [],
        companies: [],
      },
    };
  },
  computed: {
    ...mapGetters(["getConsultants", "getTags", "getToolbar"]),
    userId() {
      return this.getToolbar.user.id;
    },
    userType() {
      return true;
    },
    fields() {
      //   console.log(this.model)
      if (!this.model) return [];

      return Object.keys(this.model).map((key) => {
        return {
          key,
          value: this.model[key],
        };
      });
    },
  },
  methods: {
    hideHomeDropDownMenu() {
      this.hideHomeMenu = false;
    },
    toogleNavigation() {
      const frame = document.querySelector(".iframe-window");
      frame.contentWindow.postMessage(
        { message: "toggleNavigation", value: "/crm" },
        "*"
      );
    },
    hideSearchResult() {
      this.searchHeader = "";
    },
    hide() {
      this.hideSearch = false;
    },
    viewNotification(id) {
      this.showNotification = false;
      this.$router.push({ name: "notification-view", params: { id: id } });
    },
    declineNotification(id) {
      this.$store.dispatch("DECLINE_TOBE_MEMBER", { id: id });
      this.showNotification = false;
    },
    hideDropDownMenu() {
      this.hideMenu = false;
    },
    checkLogout(route) {
      if (route === "Logout") {
        return true;
      }
    },
    moveto() {
      this.$router.push({ name: "people_search" });
    },
    newRoute(path) {
      router.push(path);
    },
    gotoProfile(item, type) {
      let vm = this;
      vm.hideSearch = true;
      vm.searchHeader = "";
      if (type == "people") {
        if (item.account_type == 1 || item.account_type == 4) {
          let item_id = window.btoa(item.id);
          let name =
            item.first_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item.last_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item_id;
          vm.$router.push({
            name: "consultant-public-profile",
            params: { name: name },
          });
        } else if (item.account_type == 2) {
          let item_id = window.btoa(item.id);
          let name =
            item.first_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item.last_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item_id;
          vm.$router.push({
            name: "customer-public-profile",
            params: { name: name },
          });
        } else if (item.account_type == 3) {
          let item_id = window.btoa(item.id);
          let name =
            item.first_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item.last_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item_id;
          vm.$router.push({
            name: "consultant-public-profile",
            params: { name: name },
          });
        }
      } else if (type == "companies") {
        let item_id = window.btoa(item.id);
        let name = item.name.toLowerCase().replace(/\s/g, "-") + "-" + item_id;
        vm.$router.push({
          name: "supplier-public-profile",
          params: { name: name },
        });
      } else if (type == "assignments") {
        let item_id = window.btoa(item.id);
        let name = item.title.toLowerCase().replace(/\s/g, "-") + "-" + item_id;
        vm.$router.push({
          name: "assignment-public-profile",
          params: { name: name },
        });
      }
    },
    gotoTag(tag) {
      this.hideSearch = true;
      this.searchHeader = "";
      this.$router.push({ name: "feeds", params: { tag: tag } });
    },
    logOut() {
      let vm = this;
      vm.$store.dispatch("AUTH_LOGOUT");
      vm.$cookies.remove("project-token");
      vm.$cookies.remove("employment-token");
      vm.$localStorage.remove("logged_user_data");
      vm.$router.push({ name: "login" });
    },
    manageDialogSearch(dial) {
      this.$store.dispatch("DIALOG_SEARCH", dial);
    },
    showDialogSearch() {
      this.manageDialogSearch(!this.getDialogSearch);
    },
    outside: function (e) {
      this.manageDialogSearch(false);
    },
    accept(notification) {
      this.$store.dispatch("GRANT_PERMISSION", { member: notification });
    },
    decline() { },
    hideResults() {
      this.hideSearch = true;
    },
    playSound() {
      this.audio.play();
    },
    searchAllData(val) {
      let vm = this;
      vm.$store
        .dispatch("MAIN_SEARCH", { query: val })
        .then((response) => {
          console.log(response.data);
          vm.search_result = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
  },
  watch: {
    searchHeader: function (val) {
      if (val !== "" && val !== " ") {
        this.hideSearch = false;
        if (!val.startsWith("#")) {
          this.toggleSearch = true;
          this.searchAllData(val);
        } else {
          this.toggleSearch = false;
          this.$store.dispatch("POST_SEARCH_TAGS", { query: val.substring(1) });
        }
      }
    },
  },
  mounted() {
    this.audio = new Audio(require("@/assets/audio/sound.mp3"));
    this.$socket.emit("register", this.userId);
  },
  created() {
    this.$store.dispatch("TITLE_BAR_INFO");
  },
};
</script>

<style lang="scss" scoped>
a {
  color: #fff;
  text-decoration: none;

  &:hover {
    text-decoration: none;
    color: #fff;
  }
}

.mob {
  display: none;
}

.header {
  z-index: 999980;
  position: fixed;
  width: 100%;
  background: linear-gradient(45deg, #1ba5a4, #1885ad);
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 700px) and (max-width: 1200px) {
    justify-content: flex-end;
    padding-right: 30px;
  }

  .school-profile-widget {
    display: flex;
    align-items: center;
    position: absolute;
    left: 17px;

    .btn-menu {
      margin-right: 10px;

      img {
        width: 20px;
      }
    }

    .school-profile-image {
      img {
        width: 25px;
        height: 25px;
        border-radius: 50%;
        margin-right: 10px;
        object-fit: cover;
      }
    }

    .school-profile-name {
      font-size: 13px;
      font-weight: bold;
      color: #d9d9d9;
      overflow: hidden;
      text-decoration: none;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 139px;
    }
  }

  .__contents-items {
    width: 900px;
    display: flex;
    align-items: center;

    @media (min-width: 700px) and (max-width: 1200px) {
      margin: unset;
    }

    @media (min-width: 300px) and (max-width: 750px) {
      display: flex;
      width: 90%;
    }

    .company-profile {
      position: absolute;
      top: 10px;
      right: 10px;
    }

    .logo__search {
      display: flex;
      align-items: center;
      width: calc(100% - 260px);
      margin-right: 10px;

      @media (min-width: 300px) and (max-width: 600px) {
        margin-right: 35px;
      }


      .band {
        width: 124px;
        padding-top: 12px;
        padding-left: 0 !important;
        display: flex;
        align-items: center;
        margin-right: 10px;

        @media (min-width: 300px) and (max-width: 600px) {
          width: 35px;
        }

        a {
          img {
            margin-left: 0;
            padding-left: 0;
          }
        }
      }

      @media (min-width: 300px) and (max-width: 750px) {
        display: flex;
        width: 100%;

        .norm {
          display: none;
        }

        .mob {
          display: unset;
          margin-right: 10px;
        }
      }




      .search {
        position: relative;
        width: calc(100% - 130px);
        font-size: 14px;
        color: #808080;
        font-weight: normal;

        @media (min-width: 300px) and (max-width: 650px) {
          margin-left: 0;
          width: 79%;
          transition: 1000ms ease-in-out;

          &.full {
            width: 95%;
            transition: 1000ms ease-in-out;
          }
        }

        .search-input {
          width: 100%;
          outline: none;
          background-color: #ffffff;
          resize: none;
          height: 35px;

          @media (min-width: 300px) and (max-width: 650px) {
            width: 100%;
          }

          .widget_search-input {
            font-size: 14px;
          }
        }

        .__results {
          position: absolute;
          left: 0;
          top: 42px;
          overflow-y: auto;
          height: 400px;
          width: 100%;

          @media (min-width: 300px) and (max-width: 650px) {
            width: 100%;
          }

          box-shadow: 0 4px 3px rgba(0, 0, 0, 0.16);
          z-index: 999;
          background: #fff;

          .result-header {
            background: #f4f4f4;
            padding: 5px 12px;
          }

          .__item {
            display: flex;
            cursor: pointer;
            border-bottom: 0.4px solid rgba(102, 102, 102, 0.4);
            align-items: center;
            padding: 8px 9px;

            img {
              width: 40px;
              height: 40px;
              padding: 3px;
              border-radius: 100px;
              border: 1px solid #808080;
              object-fit: cover;
              margin-right: 10px;

              @media (min-width: 300px) and (max-width: 650px) {
                width: 38px;
                height: 38px;
              }
            }

            .__col {
              display: flex;
              flex-direction: column;

              .__username {
                font-weight: normal;
                font-size: 14px;

                @media (min-width: 300px) and (max-width: 650px) {
                  font-size: 12px;
                }
              }

              .__names {
                font-weight: normal;
                /*@media (min-width: 300px) and (max-width: 650px) {*/
                /*  font-size: 8px;*/
                /*}*/
              }
            }

            .hash {
              width: 40px;
              height: 40px;
              border-radius: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              border: 1px solid #cccccc;

              span {}
            }
          }
        }
      }
    }

    .__bar {
      width: 260px;
      padding-left: 3px;
      padding-right: 2px;
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      position: relative;

      img.profile {
        width: 20px;
        height: 20px;
        object-fit: cover;
      }

      img {
        width: 20px;
        height: 20px;
      }

      .__menu-item {
        box-sizing: border-box;
        background: #2c2c2c;
        margin-right: 0;

        @media (min-width: 300px) and (max-width: 650px) {
          display: none;
        }
      }

      a {
        box-sizing: border-box;

        &:hover {
          /*.dot{*/
          /*  opacity: 1;*/
          /*}*/
        }

        span {
          font-size: 12px;
          box-sizing: border-box;
          padding: 3px 5px 3px 2px !important;

          &:hover {
            font-weight: bold;
          }
        }

        .__active {
          .dot {
            opacity: 1;
          }
        }

        img {
          width: 20px;
          height: 20px;
        }

        .m__1 {
          margin-top: 2px;
        }
      }

      .__dropdown-results {
        position: absolute;
        right: 0;
        width: 150px;
        border-radius: 5px;
        top: 30px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.16);
        z-index: 999;
        padding: 10px 0;
        background: #fff;

        .__dropdown-item {
          display: flex;
          padding: 0 10px;
          justify-content: center;
          align-items: center;

          &:hover {
            background: rgba(24, 133, 173, 0.4);
            color: #fff;

            a {
              span {
                color: #fff;
              }
            }
          }

          a {
            padding: 5px;

            span {
              color: #1885ad;

              &:hover {
                font-weight: normal;
                color: #fff;
              }
            }
          }
        }
      }

      @media (min-width: 300px) and (max-width: 750px) {
        display: none;
      }
    }
  }




}

.__colored {
  color: #1ba5a4 !important;
}

.__btns {
  display: flex;
  width: 40%;
  margin-left: 50px;
  margin-top: 10px;
  justify-content: space-between;

  .cancel {
    color: #1ba5a4;
    cursor: pointer;
    font-weight: normal;
    height: 15px;
    padding: 0px 10px;
    font-size: 12px;
  }

  .save {
    background: #1ba5a4;
    color: #fff;
    font-size: 12px;
    font-weight: normal;
    cursor: pointer;
    border-radius: 5px;
    height: 15px;
    padding: 0px 10px;
  }
}

.badge {
  position: absolute;
  background: #ff1d1d;
  min-width: 15px;
  border-radius: 100%;
  margin: 0 !important;
  color: #fff;
  min-height: 16px;
  padding-top: 4px;
  text-align: center;
  top: -7px;
  right: -5px;
  font-size: 9px;

  &:hover {
    color: #fff !important;
  }
}

.drop-down-container {
  position: absolute;
  width: 350px;
  background: #fff;
  box-shadow: -8px 10px 7px rgba(0, 0, 0, 0.16);
  top: 35px;
  right: 15px;

  span {
    color: #707070;

    &:hover {
      font-weight: normal;
    }
  }

  .__title {
    padding: 5px 10px;
    display: flex;
    justify-content: space-between;

    span {
      margin: 0 !important;
      padding: 0 !important;

      &:hover {
        font-weight: normal !important;
      }
    }

    .__grey {
      color: #707070;
      cursor: pointer;

      &:hover {
        font-weight: bold !important;
      }
    }
  }

  .__body {
    background: #f0f0f0;
    width: 100%;

    .__item {
      display: flex;
      width: 100%;
      padding: 10px;
      border-bottom: 0.5px solid #707070;
      font-size: 12px;

      img {
        margin-right: 20px;
        width: 50px;
        height: 50px;
        border-radius: 100%;
      }

      .__contents {
        display: flex;
        color: #707070;
        width: 100%;
        flex-direction: column;

        h2 {
          color: #000;
          margin: 0;
          font-size: 13px;
        }

        p {
          margin: 0;
        }

        a {
          margin: 0;
        }

        span {
          margin: 0;
          padding: 0;
        }

        .__actions {
          align-self: flex-end;
          display: flex;

          button {
            padding-left: 15px;
            padding-right: 15px;
          }

          .__yes {
            background: #1885ad;
            border-radius: 5px;
            color: #fff;
          }
        }
      }
    }
  }

  .__footer {
    padding-left: 10px;
    padding-top: 5px;
    padding-bottom: 5px;

    span {
      cursor: pointer;
    }
  }
}

.dot {
  width: 20px;
  height: 3px;
  margin: 5px 0 0 0px;
  background: #fff;
  opacity: 0;
  border-radius: 5px;
  position: absolute;
  bottom: -4px;
}

.__active {
  .dot {
    opacity: 1;
  }
}

.img {
  border-radius: 100%;
  width: 30px;
  height: 30px;
  margin-right: 0;
  margin-top: 2px;
}

.home {
  margin-top: 2px;
}

.lt {
  position: relative;

  img {
    cursor: pointer;
  }
}
</style>